/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2019] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

var NProgress = require('nprogress');

var NavUtils = require('psa-core/util/nav');

var Scaffold = require('common/layout/Scaffold');

var GetEntityIdentifiers = require('../../common/services/GetEntityIdentifiers');
var GetEntityRiskMatrix = require('../services/GetEntityRiskMatrix');

var DepRiskMatrixDashboardView = require('../views/DepRiskMatrixDashboardView');

module.exports = function(entityId, riskMatrixId) {
  NProgress.start();
  NProgress.set(0.6);

  $.when(GetEntityIdentifiers(entityId), GetEntityRiskMatrix(riskMatrixId))
    .done(function(entityIdentifiers, entityRiskMatrix) {
      NavUtils.navigate('#dep/entity/' + entityId + '/risk-matrix/' + riskMatrixId + '/dashboard');
      Scaffold.content.show(
        new DepRiskMatrixDashboardView({
          viewMode: 'int',
          model: new Backbone.Model({
            entityId: entityId,
            entityName: entityIdentifiers.entityName,
            entityTypeId: entityIdentifiers.entityTypeId,
            entityCategoryId: entityIdentifiers.categoryId,
            riskMatrix: entityRiskMatrix
          })
        })
      );
      NProgress.done();
    })
    .fail(function(err) {
      NProgress.done();
    });
};
